const RequiredFields = (field, value=null) => {
    if (value === null && field.value.trim() === "" || value && value.trim() === "") {
		field.style.border = "1px solid red"; return false;
    } else {
		field.style.border = "1px solid lightgray"; return true
    };
}

export default RequiredFields
